import { createSlice } from "@reduxjs/toolkit";

import { INotificationState } from "../types/notification";

const initialState: INotificationState = {
  discoveryNotifications: [],
  discoveryNotificationLastIndex: 0,
  activeDiscoveryNotification: null,
  startShow: false,
  specificationId: "",
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setDiscoveryNotifications: (state, action) => {
      // notication changes
      state.discoveryNotifications = action.payload;
    },
    addDiscoveryNotification: (state, action) => {
      state.discoveryNotifications.push(action.payload);
    },
    removeDiscoveryNotification: (state, action) => {
      state.discoveryNotifications = state.discoveryNotifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    updateDiscoveryNotification: (state, action) => {
      const index = state.discoveryNotifications.findIndex(
        (notification) => notification.id === action.payload.id
      );
      if (index !== -1) {
        state.discoveryNotifications[index] = action.payload;
      }
    },
    setActiveDiscoveryNotification: (state, action) => {
      // set active discovery notification
      state.activeDiscoveryNotification = action.payload;
    },
    setDiscoveryNotificationLastIndex: (state, action) => {
      state.discoveryNotificationLastIndex = action.payload;
    },
    setStartShow: (state, action) => {
      // start show notification
      state.startShow = action.payload;
    },
    setSpecificationId: (state, action) => {
      state.specificationId = action.payload;
    },
    clearNotification: (state) => {
      state.discoveryNotifications = [];
      state.discoveryNotificationLastIndex = 0;
      state.activeDiscoveryNotification = null;
      state.startShow = false;
      state.specificationId = null;
    },
  },
});

export const {
  setDiscoveryNotifications,
  addDiscoveryNotification,
  removeDiscoveryNotification,
  updateDiscoveryNotification,
  setStartShow,
  setActiveDiscoveryNotification,
  setDiscoveryNotificationLastIndex,
  clearNotification,
} = notificationSlice.actions;
export default notificationSlice.reducer;
